import { Upload, FileText, Image, File, Trash2 } from "feather-icons-react";
import PropTypes from 'prop-types'
import IconComponent from '../button/IconComponent';

const getFileIcon = (filename) => {
    const extension = filename.split(".").pop().toLowerCase();
    switch (extension) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
            return <Image className="w-6 h-6 text-yellow-500" />;
        case "pdf":
            return <FileText className="w-6 h-6 text-red-500" />;
        case "doc":
        case "docx":
            return <FileText className="w-6 h-6 text-blue-500" />;
        case "xls":
        case "xlsx":
            return <FileText className="w-6 h-6 text-green-500" />;
        default:
            return <File className="w-6 h-6 text-gray-500" />;
    }
};

const DocumentCardComponent = ({ titleName, iconName, data }) => {
    if (!data || data.length === 0) return null; // Handle empty data

    return (
        <div className="bg-white shadow-lg rounded-xl mt-6 lg:mt-0 flex-1 px-5 border-l border-r border-gray-200 pt-5 lg:pt-0">
            {/* Header */}
            <div className="flex flex-col sm:flex-row items-center p-5 border-gray-200 dark:border-dark-5">
                {iconName && <IconComponent icon={iconName} color='gray' />} &nbsp;&nbsp;
                <h1>{titleName}</h1>
            </div>

            {/* Dynamic Details Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {data.map((file, index) => (
                    <div key={index} className="flex items-center p-1 bg-gray-10 rounded-lg shadow-sm transition-transform hover:scale-105 duration-200">
                        <div className="flex items-center gap-2">
                            <a
                                rel="noopener noreferrer"
                                href={file.image_address}
                                target="_blank"
                                className="flex items-center gap-2 text-blue-600 hover:underline"
                            >
                                {getFileIcon(file.image_address.split('/').pop())}
                                <span>{file.image_address.split('/').pop()}</span>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

// Define Prop Types
DocumentCardComponent.propTypes = {
    titleName: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
        })
    ).isRequired,
};

export default DocumentCardComponent;
